import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useListings } from "../../hooks/useListings";
import PostForm from "../../components/PostForm";

const EditPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchListing, editListing } = useListings();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchListing(id);
        setPost(data);
      } catch (err) {
        setError("Could not load post.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (
    formValues,
    staticFields,
    categoryId,
    postFormFields
  ) => {
    setSaving(true);
    const newValues = { ...formValues };
    staticFields.forEach((field) => {
      if (field.type === "checkbox" && !(field.label in newValues)) {
        newValues[field.label] = false;
      }
    });
    postFormFields.forEach((field) => {
      if (field.type === "checkbox") {
        const key = `attr_${field.label}`;
        if (!(key in newValues)) {
          newValues[key] = false;
        }
      }
    });
    if (Array.isArray(newValues.images)) {
      newValues.images = newValues.images.filter(
        (url) => typeof url === "string"
      );
    } else {
      newValues.images = [];
    }
    try {
      const token = localStorage.getItem("token");
      await editListing(id, newValues, token);
      navigate("/my-posts");
    } catch (err) {
      alert("Failed to update post. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="p-8 text-center">Loading...</div>;
  if (error) return <div className="p-8 text-center text-red-600">{error}</div>;
  if (!post) return <div className="p-8 text-center">Post not found.</div>;

  return (
    <div className="min-h-screen bg-gray-100 font-sans text-lg relative">
      <div className="max-w-2xl mx-auto pt-8 px-4 pb-12">
        <button
          onClick={() => navigate(-1)}
          className="text-blue-600 hover:underline text-xs mb-4"
        >
          &lt; back
        </button>
        <h2 className="text-base font-normal mb-6">edit your post</h2>
        <PostForm
          mode="edit"
          initialValues={{
            ...post,
            // flatten attributes for PostForm
            ...Object.fromEntries(
              Object.entries(post.attributes || {}).map(([k, v]) => [
                `attr_${k}`,
                v,
              ])
            ),
          }}
          categoryId={post.category_id}
          onSubmit={handleSubmit}
          submitLabel="Save Changes"
          loading={saving}
          onCancel={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default EditPost;
